import React, {FC} from "react"
import {FormattedMessage} from "@irati/utils/lang"
import {Label} from "@irati/ui/src/Typography"
import Flex from "@irati/ui/src/Flex"

const CompanyValuesEmpty: FC = () => (
  <Flex alignItems="center" direction="column">
    <Label paddingBottom={2}>
      <FormattedMessage id="admin.companyValues.list.empty" />
    </Label>
  </Flex>
)

export default CompanyValuesEmpty
